import { render, staticRenderFns } from "./Image-Attachment.vue?vue&type=template&id=66eb34a7"
import script from "./Image-Attachment.vue?vue&type=script&lang=js"
export * from "./Image-Attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports